import { createStore, combineReducers, applyMiddleware } from 'redux'
import {thunk} from 'redux-thunk'
import ticketsScannerReducer from './ticketsScanner'
import scheduleReducer from './schedule'
import memberReducer from './member'
import customFormReducer from './customForm'

const rootReducer = combineReducers({
  ticketsScanner: ticketsScannerReducer,
  schedule: scheduleReducer,
  member: memberReducer,
  customForm: customFormReducer,
})

const store = createStore(
  rootReducer,
  applyMiddleware(thunk)
)

export default store
